/* eslint-disable @nx/enforce-module-boundaries */
import { Box, HStack, Progress, Stack, Text, Link } from '@mybridge/ui';

import { useContext, useEffect } from 'react';
import { getUserFullName } from 'v4/lib/commons';
import { DiskContext } from '../../context';
import { humanFileSize } from 'v4/components/utils';
import { MyDiskUsageProgress } from '../../disk-usage-progress';
import { TeamsContext } from 'v4/snippets/teams/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const TeamDiskUsagePanel = () => {
  const { selectedMainDir } = useContext(DiskContext);
  const {
    isOrganizer,
    diskOrganizer,
    userProfileInfo,
    teamDetails,
    changeDiskSubscriberDisc,
    teamOrganizers,
  } = useContext(TeamsContext);
  const { t } = useTranslator();

  return (
    <>
      <Stack>
        <MyDiskUsageProgress>
          {userProfileInfo?.id === teamDetails?.disk_payer_details?.id ? (
            <Link fontSize="sm" href="/settings/subscriptions">
              {t('myDisk.upgrade') || "Upgrade"}
            </Link>
          ) : (
            ''
          )}
        </MyDiskUsageProgress>

        <HStack flexWrap="wrap">
          <Text fontSize="sm" flexShrink={0} flex={1}>
            {t('myDisk.subscriber') || "Subscriber"} {getUserFullName(teamDetails?.disk_payer_details)}
          </Text>
          {teamOrganizers?.length >= 2 &&
          userProfileInfo?.id === teamDetails?.disk_payer_details?.id ? (
            <Box>
              <Link
                onClick={(e) => changeDiskSubscriberDisc?.onOpen?.()}
                fontSize="sm"
                href="#"
              >
                {t('myDisk.changeSubscriber') || "Change subscriber"}
              </Link>
            </Box>
          ) : (
            ''
          )}
        </HStack>
      </Stack>
    </>
  );
};
